import {getSheet} from "../sheets";

export function init(view) {
	view.attachEvent("onUndo", (action, row, column, value) => {
		if (action == "gridlines-hide")
			hideGridlines(view, value);
	});
}

export function hideGridlines(view, state = true, page){
	let oldState;
	page = page || view.getActiveSheet();

	if (page == view.getActiveSheet()) {
		const grid = view.$$("cells");
		oldState = grid.$view.className.indexOf("webix_borderless") != -1;

		if (state == "toggle")
			state = !oldState;

		if(state != oldState){
			if(state)
				webix.html.addCss(grid.$view, "webix_borderless", true);
			else
				webix.html.removeCss(grid.$view, "webix_borderless");
			view.callEvent("onCommand", [{id:"toolbar-update", name:"hide-gridlines", value: state}]);
		}
	}
	else{
		const sheet = getSheet(view, page);
		if(sheet){
			if(!sheet.content.table)
				sheet.content.table = {gridlines: 1};

			oldState = !sheet.content.table.gridlines;

			if (state === "toggle")
				state = !oldState;

			sheet.content.table.gridlines = state ? 0 : 1;
		}
		else return;
	}

	if(state != oldState)
		view.callEvent("onAction", ["gridlines-hide", {newValue: state, value: oldState, page}]);
}

export function serialize(view, data){
	data.table.gridlines = view.$$("cells").$view.className.indexOf("webix_borderless") !=-1?0:1;
}

export function load(view, data){
	var mode = false;
	if(!webix.isUndefined(data.table) && !webix.isUndefined(data.table.gridlines))
		mode = !data.table.gridlines;
	hideGridlines(view, mode);
}